import React from 'react';
import { Routes, Route, BrowserRouter as Router, useLocation, useNavigate } from 'react-router-dom';
import StudiesPage from '@/pages/Studies';
import StudyDashboard from '../pages/StudyDashboard';
import Header from '../components/organisms/Header';
import DrawerTemplate from '../components/templates/DrawerTemplate';
import ComingSoon from '../pages/ComingSoon';
import Company from '../pages/Company';
import Dashboard from '../pages/Dashboard';
// import Differentiators from '../pages/Differentiators';
import DataDashboard from '../pages/DataDashboard';
import Forecast from '../pages/Forecast';
import Home from '../pages/Home';
import Login from '../pages/Login';
import Segments from '../pages/Segments';
import Suppliers from '../pages/Suppliers';
import SupplierDashboard from '../pages/SupplierDashboard';
import Token from '../pages/Token';

type LayoutType = 'none' | 'header' | 'drawer' | 'both';

// Configuration object for routes
const routeConfig = {
  '/': { title: 'Login', layout: 'none' as LayoutType },
  '/home': { title: 'Home', layout: 'header' as LayoutType },
  '/dashboard': { title: 'Dashboard', layout: 'both' as LayoutType },
  '/company': { title: 'Company', layout: 'both' as LayoutType },
  '/segments': { title: 'Segments', layout: 'both' as LayoutType },
  '/study': { title: 'Study', layout: 'both' as LayoutType },
  '/study/:studyId': { title: 'Study Dashboard', layout: 'both' as LayoutType },
  '/studies': { title: 'Study', layout: 'header' as LayoutType },
  '/getAToken': { title: 'token', layout: 'none' as LayoutType },
  '/forecast': { title: 'Forecast', layout: 'both' as LayoutType },
  '/suppliers': { title: 'Suppliers', layout: 'header' as LayoutType },
  '/soon': { title: 'Soon', layout: 'none' as LayoutType },
  // '/survayform': { title: 'SurvayForm', layout: 'none' as LayoutType }, // Add new public form route
  '/data': { title: 'Data', layout: 'none' as LayoutType },
  '/companies/:companyName': { title: 'Company Details', layout: 'header' as LayoutType },
};

// const publicRoutes = ['/', '/getAToken', '/form'];

const isPathMatch = (routePattern: string, pathname: string) => {
  const patternSegments = routePattern.split('/').filter(Boolean);
  const pathSegments = pathname.split('/').filter(Boolean);

  if (patternSegments.length !== pathSegments.length) {
    return false;
  }

  return patternSegments.every((segment, index) => {
    return segment.startsWith(':') || segment === pathSegments[index];
  });
};

const DrawerWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  let currentRoute = null;
  // Match dynamic routes

  if (location.pathname.startsWith('/companies/')) {
    currentRoute = routeConfig['/companies/:companyName'];
  } else {
    currentRoute = routeConfig[location.pathname];
  }

  const drawerItems = [
    // { text: 'Study Home', icon: 'home', path: '/study', onClick: () => navigate('/study') },
    // { text: 'Home', icon: 'home', path: '/home', onClick: () => navigate('/home') },
    {
      text: 'Dashboard',
      icon: 'dashboard',
      path: '/dashboard',
      onClick: () => navigate('/dashboard'),
    },
    {
      text: 'Companies',
      icon: 'company',
      path: '/company',
      onClick: () => navigate('/company'),
    },
    {
      text: 'Segments',
      icon: 'analysis',
      path: '/segments',
      onClick: () => navigate('/segments'),
    },

    {
      text: 'Forecast',
      icon: 'forecast',
      path: '/forecast',
      onClick: () => navigate('/forecast'),
    },
  ];

  // You can have separate items for header if needed
  const headerItems = [
    { text: 'Home', onClick: () => navigate('/home') },
    { text: 'Studies', onClick: () => navigate('/studies') },
    { text: 'Suppliers', onClick: () => navigate('/suppliers') },
    { text: 'Industries', onClick: () => navigate('/soon') },
    { text: 'Applications', onClick: () => navigate('/soon') },
    // { text: 'Data', onClick: () => navigate('/data') },
    // Add more header-specific items here
  ];

  if (!currentRoute) {
    return <>{children}</>;
  }
  console.log('Current Route Layout:', currentRoute.layout);
  console.log('Current Route Title:', currentRoute.title);
  // Render appropriate layout based on layout type
  switch (currentRoute.layout) {
    case 'both':
      return (
        <>
          <Header title={currentRoute.title} navigationItems={headerItems} />
          <DrawerTemplate title={currentRoute.title} items={drawerItems}>
            {children}
          </DrawerTemplate>
        </>
      );

    case 'header':
      return (
        <>
          <Header title={currentRoute.title} navigationItems={headerItems} />
          {children}
        </>
      );

    case 'drawer':
      return (
        <DrawerTemplate title={currentRoute.title} items={drawerItems}>
          {children}
        </DrawerTemplate>
      );

    case 'none':
    default:
      return <>{children}</>;
  }
};

const Routers: React.FC = () => {
  return (
    <Router>
      <DrawerWrapper>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/company" element={<Company />} />
          <Route path="/getAToken" element={<Token />} />
          <Route path="/segments" element={<Segments />} />
          {/* <Route path="/differentiators" element={<Differentiators />} /> */}
          <Route path="/forecast" element={<Forecast />} />
          <Route path="/studies" element={<StudiesPage />} />
          <Route path="/soon" element={<ComingSoon />} />
          <Route path="/suppliers" element={<Suppliers />} />
          <Route path="/data" element={<DataDashboard />} />
          {/* <Route path="/surveyform/:token" element={<SurveyForm />} /> */}
          {/* <Route path="*" element={<ErrorPage />} /> */}
          <Route path="/study/:studyId" element={<StudyDashboard />} />
          <Route path="/companies/:companyName" element={<SupplierDashboard />} />
        </Routes>
      </DrawerWrapper>
    </Router>
  );
};

export default Routers;
